export const parseGene = (genes: string) => {
  const gene = BigInt(genes).toString(2).padStart(256, "0");
  return gene;
};
